import { IMatchExporter } from "../IFileConverter";
import { Match, CodeEventGroup, MatchEvent } from "../../models";
import { formatDate } from "@angular/common";
import { Inject, LOCALE_ID } from "@angular/core";


/*
<file>
  <SESSION_INFO>
    <start_time>2018-06-20 09:13:47 +0000</start_time>
  </SESSION_INFO>
  <ALL_INSTANCES>
    <instance>
      <ID>13</ID>
      <start>98.88</start>
      <end>109.89</end>
      <code>A25 Entry</code>
      <label>
        <text>Side</text>
      </label>
    </instance>
    <instance>
      <ID>105</ID>
      <start>899.37</start>
      <end>911.38</end>
      <code>Green Card</code>
    </instance>
    <instance>
      <ID>12</ID>
      <start>184.14</start>
      <end>206.14</end>
      <code>Outlet</code>
      <label>
        <group>Outlet</group>
        <text>Pocket</text>
      </label>
    </instance>
  </ALL_INSTANCES>
  <ROWS>
    <row>
      <code>A25 Entry</code>
      <R>17694</R>
      <G>41779</G>
      <B>58982</B>
    </row>
  </ROWS>
</file>
*/

export class SportsCodeFileExporter implements IMatchExporter {
    
    public name = 'SportsCode';
    public counter = 1;

    constructor(@Inject(LOCALE_ID) private locale: string) {}

    convert(match: Match): string {
        let doc = document.implementation.createDocument(null, 'file', null);

        doc.documentElement.appendChild(this.buildSessionInfo(doc, match));
        doc.documentElement.appendChild(this.buildAllInstances(doc, match));
        doc.documentElement.appendChild(this.buildRows(doc, match));

        return new XMLSerializer().serializeToString(doc);
    }

    private buildSessionInfo(doc: Document, match: Match): HTMLElement {
        let container = doc.createElement('SESSION_INFO');
        let startTime = doc.createElement('start_time');
        const dateValue = doc.createTextNode(this.getFormattedStartTime(match));
        startTime.appendChild(dateValue);
        container.appendChild(startTime);
        return container;
    }

    private buildAllInstances(doc: Document, match: Match): HTMLElement {
        let container = doc.createElement('ALL_INSTANCES');

        if(!match.events)
            return container;
        
        match.events.forEach((codeGroup: CodeEventGroup) => {
            codeGroup.events.forEach((matchEvent: MatchEvent) => {
                container.appendChild(this.buildInstance(doc, matchEvent, codeGroup.eventType));
            });
        });

        return container;
    }

    private buildRows(doc: Document, match: Match): HTMLElement {
        let container = doc.createElement('ROWS');

        if(!match.events)
            return container;

        match.events.forEach((codeGroup: CodeEventGroup) => {
            container.appendChild(this.buildRow(doc, codeGroup));
        });
        
        return container;
    }

    private buildInstance(doc: Document, matchEvent: MatchEvent, eventType: string): HTMLElement {

        const instance = doc.createElement('instance');
        
        const id = doc.createElement('ID');
        const start = doc.createElement('start');
        const end = doc.createElement('end');
        const code = doc.createElement('code');

        const idValue = doc.createTextNode((this.counter++).toString());
        const startValue = doc.createTextNode(this.calculateStartTime(matchEvent).toString());
        const endValue = doc.createTextNode(this.calculateEndTime(matchEvent).toString());
        const codeValue = doc.createTextNode(eventType);

        id.appendChild(idValue);
        start.appendChild(startValue);
        end.appendChild(endValue);
        code.appendChild(codeValue);

        instance.appendChild(id);
        instance.appendChild(start);
        instance.appendChild(end);
        instance.appendChild(code);

        if(matchEvent.tags && matchEvent.tags.length > 0) {
            const label = doc.createElement('label');
            const text = doc.createElement('text');

            const textValue = doc.createTextNode(matchEvent.tags[0]);

            text.appendChild(textValue);
            label.appendChild(text);
            instance.appendChild(label);
        }

        return instance;
    }

    private buildRow(doc: Document, codeGroup: CodeEventGroup): HTMLElement {
        const row = doc.createElement('row');
        const code = doc.createElement('code');
        const r = doc.createElement('R');
        const g = doc.createElement('G');
        const b = doc.createElement('B');

        const codeText = doc.createTextNode(codeGroup.eventType);
        const rText = doc.createTextNode('17694');
        const gText = doc.createTextNode('41779');
        const bText = doc.createTextNode('58982');

        code.appendChild(codeText);
        r.appendChild(rText);
        g.appendChild(gText);
        b.appendChild(bText);

        row.appendChild(code);
        row.appendChild(r);
        row.appendChild(g);
        row.appendChild(b);
        return row;
    }

    public calculateStartDate(match: Match): string {
        const result = match.matchDate;
        return result;
    }

    public calculateStartTime(matchEvent: MatchEvent): number {
        const result = matchEvent.seconds - matchEvent.leadSeconds;
        return Math.max(result, 0);
    }

    public calculateEndTime(matchEvent: MatchEvent): number {
        return matchEvent.seconds + matchEvent.lagSeconds;
    }

    public getFormattedStartTime(match: Match): string {
        const startDate = new Date(match.matchDate);
        return formatDate(startDate, 'yyyy-MM-dd hh:mm:ss +0000', this.locale);
    }
}